<template>
    <div class="pt-16">
        <div class="row align-items-center justify-content-between mb-16 pr-16 pl-16">
            <div class="col-6 col-sm-4 d-block d-md-none text-left mb-16">
                <button id="properties-filters-button-mobil" class="btn btn-gray">{{__('pages.filter.title')}}</button>
            </div>
            <div class="col-6 col-sm-4 text-md-left text-right mb-16">
                <button type="button" class="btn rounded mr-8" :class="grid == 'vertical' ? 'btn-orange-inverse' : 'btn-gray'" @click="grid = 'vertical'"><i class="far fa-th-large"></i></button>
                <button type="button" class="btn rounded" :class="grid == 'horizontal' ? 'btn-orange-inverse' : 'btn-gray'" @click="grid = 'horizontal'"><i class="far fa-th-list"></i></button>
            </div>
            <div class="col-12 col-sm-4 col-md-6 col-lg-4 text-right mb-16">
                <select v-model="sort" class="selectpicker">
                    <option v-for="option in sortings" :value="option.code">{{option.label}}</option>
                </select>
            </div>
        </div>
        <div class="list-container pb-32">
            <template v-if="grid == 'vertical'">
                <vertical-list :properties="properties" :item_number="item_number" :property_route="property_route" :params="`?when_start=${filter.when_start}&when_end=${filter.when_end}&booking_type=${filter.booking_type}&time_from=${filter.time_from}&time_to=${filter.time_to}`"></vertical-list>
            </template>
            <template v-if="grid == 'horizontal'">
                <horizontal-list :properties="properties" :item_number="item_number" :property_route="property_route" :params="`?when_start=${filter.when_start}&when_end=${filter.when_end}&booking_type=${filter.booking_type}&time_from=${filter.time_from}&time_to=${filter.time_to}`"></horizontal-list>
            </template>
            <div v-if="item_number < properties.length" class="mt-32 text-center">
                <button type="button" class="btn btn-orange-inverse" @click="item_number += 4">{{__('pages.more_list_item')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import vertical_list from './list_item_vertical'
import horizontal_list from './list_item_horizontal'
export default {
    data(){
        return {
            grid: 'vertical',
            item_number: 8,
            sort: 'most_popular',
            sortings: [
                {label: this.__('pages.sorting.most_popular'), code: 'most_popular'},
                {label: this.__('pages.sorting.price_asc'), code: 'price_asc'},
                {label: this.__('pages.sorting.price_desc'), code: 'price_desc'},
            ]
        }
    },
    props:['property_route'],
    computed:{
        properties: {
            get(){
                return this.$root.properties;
            }
        },
        filter: {
            get(){
                return this.$root.filter;
            }
        },
        
    },
    watch:{
        'sort': function(){
            this.$root.setParams({sort: this.sort});
        }
    },
    components:{
        'vertical-list': vertical_list,
        'horizontal-list': horizontal_list
    },
    methods:{
    }
}
</script>